import {Component, inject, Input} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {MobileNavService} from './service/mobile-nav.service';
import {AppIcons} from "@/assets/icons/icons";

@Component({
  selector: 'app-mobile-header',
  standalone: true,
  imports: [],
  templateUrl: './mobile-header.component.html',
  styleUrl: './mobile-header.component.scss',
})
export class MobileHeaderComponent {
  @Input() logoSrc!: string;
  @Input() fallbackLogoPath!: string;
  @Input() logoWidth: string | undefined;
  @Input() logoHeight: string | undefined;
  nav = inject(MobileNavService);

  AppIcons = AppIcons;
  private sanitizer = inject(DomSanitizer);

  safeIcon(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
}
